










































import TopNav from '@/web/components/navigation/TopNav';
import Vue from 'vue';
import HMWidgetCard from '@/web/components/widgets/HMWidgetCard';
import { mapGetters, mapState } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import { sanitize } from '@/core/utils/utils';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  components: {
    TopNav,
    HMWidgetCard,
  },
  name: 'Widgets',
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      customDomainWidgets: 'user/customDomainWidgets',
    }),
    ...mapState('setting', ['domain']),
    widgetGroups() {
      return [
        {
          widgetInfo: {
            title: 'SETTINGS.TITLE.EXTENDED_CALENDAR',
            img: '/assets/images/settings/extended_cal_widget.png',
            code: `<iframe src="${this.getWidgetURI(
              '/widgets/calendars/full'
            )}" height="700" style="width: 90vw; max-width: 1000px" frameborder="0"></iframe>`,
          },
        },
        {
          widgetInfo: {
            title: 'SETTINGS.TITLE.MONTHLY_CALENDAR',
            img: '/assets/images/settings/monthly_cal_widget.png',
            code: `<iframe src="${this.getWidgetURI(
              '/widgets/calendars/compact'
            )}" frameborder="0" style="width: 90vw; max-width: 900px; min-height: 515px"></iframe>`,
          },
        },
        {
          widgetInfo: {
            title: 'SETTINGS.TITLE.COMPACT_CALENDAR',
            img: '/assets/images/settings/mini_cal_widget.png',
            code: `<iframe src="${this.getWidgetURI(
              '/widgets/calendars/full'
            )}" height="600" frameborder="0" style="width: 90vw; max-width: 350px"></iframe>`,
          },
        },
      ];
    },
    isDomainValid() {
      return (
        this.domain?.success &&
        this.domain?.heroku_response?.content.acm_status === 'cert issued' &&
        this.domain?.heroku_response?.content.acm_status_reason === ''
      );
    },
  },
  methods: {
    sanitize,
    async getCustomDomain() {
      try {
        await this.$store.dispatch('setting/getDomain');
      } catch (error) {
        // BE returns 404 when custom domain is not set
      }
    },
    getWidgetURI(path): string {
      const host = window.location.host;
      const protocol = window.location.protocol;

      if (this.customDomainWidgets && this.isDomainValid) {
        return `${protocol}//${this.domain?.domain}${path}`;
      }
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return getStudentViewURL(this.teacherStudioUrl, path, null);
      } else {
        const uri = `${protocol}//${host}/${this.teacherStudioUrl}${path}`;
        return uri;
      }
    },
  },
  async mounted() {
    await this.getCustomDomain();
  },
});
